import React from 'react';
import { Badge } from 'reactstrap';

export const ContractStatus = (props) => {
    return (
        <>
            {props.statusId === 1 && (
                <Badge
                    color='success'
                    className={props.customClass}
                >
                    Active
                </Badge>
            )}
            {props.statusId === 2 && (
                <Badge
                    color='danger'
                    className={props.customClass}
                >
                    Inactive
                </Badge>
            )}
            {props.statusId === 3 && (
                <Badge
                    color='danger'
                    className={props.customClass}
                >
                    Fulfilled
                </Badge>
            )}
            {props.statusId === 4 && (
                <Badge
                    color='danger'
                    className={props.customClass}
                >
                    Cancelled
                </Badge>
            )}
            {props.statusId === 6 && (
                <Badge
                    color='danger'
                    className={props.customClass}
                >
                    Suspended
                </Badge>
            )}
            {props.statusId === 7 && (
                <Badge
                    color='danger'
                    className={props.customClass}
                >
                    Expired
                </Badge>
            )}
            {props.statusId === 8 && (
                <Badge
                    color='warning'
                    className={props.customClass}
                >
                    Pending
                </Badge>
            )}
            {props.statusId === 10 && (
                <Badge
                    color='warning'
                    className={props.customClass}
                >
                    Wait
                </Badge>
            )}
        </>
    );
};
